import styled from 'styled-components';

export const OfferListItemGrid = styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 300px;
    grid-template-rows: 1fr min-content;
    width: 100%;
`;
